var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DgInput',{attrs:{"type":"phone","name":_vm.name,"label":_vm.label,"required":_vm.required,"placeholder":_vm.placeholder,"errorMessage":_vm.errorMessage,"initialValue":_vm.initialValue,"validator":_vm.validator},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }